/**
 * Exported function to register the template
 * 
 * @param {PopupRenderer} renderer static PopupRenderer class
 * 
 * @memberof vef.map.popup.templates
 */
export function opusLayer(renderer) {
    renderer.registerTemplate('opus', `
| {setTitle(properties.recorderDatasetName)} | |
|--|--|
| Depth (m) | {properties.waterDepthMeter} |
| Period | {substring(properties.analysisStartDatetime, "0", "7")} - {substring(properties.analysisEndDatetime, "0", "7")} |
| DOI | {properties.doi} |
| Quota (Gb) | {properties.pangaeaArchivedDataVolumeGb} |
| Quality Data (Days) | {properties.dataQuality} |
| Sampling Frequency (hz) | {properties.sampleRateHertz} |
`);
}